import TrialState from "../../../../models/state/trials/trial/TrialState";

export function hasWrongAnswersPremiumTrial(state: TrialState | null): boolean {
  return !!state;
}

export function getWrongAnswersSessionsInitiallyGranted(
  state: TrialState
): number {
  return state.total;
}

export function getWrongAnswersSessionsRemaining(state: TrialState): number {
  return state.remaining;
}

export function canStudyWrongAnswersSession(state: TrialState): boolean {
  return (
    hasWrongAnswersPremiumTrial(state) &&
    getWrongAnswersSessionsRemaining(state) > 0
  );
}

export function userHasFinishedWrongAnswersTrial(state: TrialState): boolean {
  return (
    hasWrongAnswersPremiumTrial(state) &&
    getWrongAnswersSessionsRemaining(state) === 0
  );
}
